import {Ticker} from '@theatre/dataverse'

const coreTicker = Ticker.raf

export default coreTicker
